exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item__secret[data-v-23519499]{width:calc(100% - 90px)}.content__dialog[data-v-23519499]{height:700px}[data-v-23519499] .el-tabs__content{height:calc(100% - 38px);overflow-y:auto}", ""]);

// exports
